/*
 * @Author: GengHH
 * @Date: 2021-11-04 17:01:17
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-11-05 22:51:24
 * @Description: file content
 * @FilePath: \Gui\ghh-ui\packages\index.js
 */

import Button from './button';
import ImgBox from './imgBox';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

const components = [Button, ImgBox];
const install = function (Vue) {
  Vue.use(BootstrapVue);
  Vue.use(IconsPlugin);
  components.forEach((component) => {
    Vue.component(component.name, component);
  });
};

export default {
  install,
  ImgBox,
  Button,
};
